import React, { useCallback } from "react";
import useGetBuildSpinnerFrame from "../../../hooks/shared/spin/useGetBuildSpinnerFrame";
import { BnbLabel, useBnbOptionalLabel } from "../../../utils/labels";
import * as Type from "../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import * as Text from "../../../../../../common-deprecated/styles/v2/lexus/utilities/Text";
import { ImageFluid } from "../../../../../../common-deprecated/styles/v2/lexus/globals/Image";
import { IconArrowLeftLong } from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { useBnbSelector } from "../../../redux/store";
import { generateImageSet } from "../../../utils/typedUtils";
import PaymentDetails from "../common/PaymentDetails";
import * as Styles from "./styles/Lease";
import { NavStep } from "../../../../shared-logic/utils/Navigation";
import BasketHeader from "../common/basket/content/BasketHeader";
import useStepUrl from "../../../hooks/shared/actions/useStepUrl";
import ButtonWithIcon from "../../../../../../common-deprecated/components/aem/lexus/button/ButtonWithIcon";
import ButtonPrimary from "../../../../../../common-deprecated/components/aem/lexus/button/ButtonPrimary";

type PropsType = {
    leaseCar: () => void;
};

const LeasePanel = (props: PropsType): JSX.Element => {
    const { leaseCar } = props;
    const car = useBnbSelector((state) => state.car);
    const financeOption = useBnbSelector((state) => state.utils.financeOption);

    const summaryStep = useStepUrl(NavStep.Summary, undefined, true);

    const [leaseNowLabel, leaseMonthlyLabel] = useBnbOptionalLabel(["leaseLeaseNow", "leaseLeaseNowMonthly"]);
    const leaseLabel =
        financeOption === "monthly" && leaseMonthlyLabel
            ? "leaseLeaseNowMonthly"
            : leaseNowLabel
              ? "leaseLeaseNow"
              : null;

    const { getImage, cacheKey } = useGetBuildSpinnerFrame(false);
    const getFrame = useCallback(() => {
        return generateImageSet(
            (width: number, height: number) => getImage(width, height, 2, { bgColour: "", padding: 0 }),
            800,
            460,
        ); // same size as mobile basket
    }, [cacheKey]);

    return (
        <>
            <Styles.Panel>
                <Styles.ImageWrapper>
                    <ImageFluid src={getFrame().src} srcSet={getFrame().srcset} sizes="" draggable={false} />
                </Styles.ImageWrapper>
                <Styles.BasketTitle>
                    {car.model.webtitleSectionName}
                    <span>{car.grade.webtitleSectionName}</span>
                </Styles.BasketTitle>
                <Type.Text as="div" mb={1}>
                    {car.body.webtitleSectionName}
                </Type.Text>
                <BasketHeader />
                <PaymentDetails />
                <Styles.ButtonWrapper>
                    {leaseLabel && (
                        <ButtonPrimary onClick={leaseCar} fullWidth>
                            <BnbLabel label={leaseLabel} />
                        </ButtonPrimary>
                    )}

                    <ButtonWithIcon hasIconLeft href={summaryStep.href}>
                        <Text.IconButton>
                            <BnbLabel label="leaseBackToSummary" />
                        </Text.IconButton>
                        <IconArrowLeftLong />
                    </ButtonWithIcon>
                </Styles.ButtonWrapper>
            </Styles.Panel>
        </>
    );
};

export default LeasePanel;
